import {
  GetMakeModelActions,
  REFRESH_REDUCERS,
  REQUESTED_MAKE_MODEL,
  REQUESTED_MAKE_MODEL_FAILED,
  REQUESTED_MAKE_MODEL_SUCCESS,
  RESET_MAKE_MODEL,
} from "../action";

type MakeModelState = {
  error: boolean;
  payload?: any[];
  year?: string;
};

const initialState = {
  error: false,
};

export default function (
  state: MakeModelState = initialState,
  action: GetMakeModelActions
) {
  switch (action.type) {
    case REQUESTED_MAKE_MODEL:
      return { ...state, year: action.payload.year, payload: [] };
    case REQUESTED_MAKE_MODEL_SUCCESS:
      return { ...state, payload: action.payload };
    case REQUESTED_MAKE_MODEL_FAILED:
      return { ...state, payload: action.payload, error: true };
    case REFRESH_REDUCERS:
      return { ...initialState };
    case RESET_MAKE_MODEL:
      return { ...initialState };
    default:
      return state;
  }
}
